// extracted by css-extract-rspack-plugin
export default {"root":"TD6LT_"};